import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { Card } from '../ui/Card';
const reviews = [{
  headline: 'First Time In 8 Years I Slept Past 5 AM',
  text: 'I am 67 and I had accepted that my sleep was ruined forever. I was up at 1:30, 3:00, 4:30 like clockwork. After about 10 days on Flow Regen, something shifted. I woke up and it was light outside. Now I regularly sleep 6–7 hours straight.',
  author: 'Mike O',
  age: '67',
  verified: true
}, {
  headline: 'My Wife Moved Back Into Our Bedroom',
  text: 'My wife had been sleeping in the guest room for almost two years because I was constantly getting up. Within three weeks, I went from 4–5 bathroom trips to usually just one, sometimes zero. She moved back in last month.',
  author: 'James T',
  age: '71',
  verified: true
}, {
  headline: 'Finally Something That Makes Biological Sense',
  text: 'I am an engineer, so I need things to make sense. When I read about the Pelvic Pressure Trap and how it is a circulation issue, a lightbulb went off. Flow Regen addresses the actual problem. I am sleeping better than I have in a decade.',
  author: 'Gregg T',
  age: '63',
  verified: true
}, {
  headline: 'Wish My Urologist Had Told Me 10 Years Ago',
  text: 'I have spent thousands on doctors, medications, and supplements. The medications worked okay but the side effects were terrible. Flow Regen has no side effects that I have noticed, and it works better than anything I have tried.',
  author: 'Josep M',
  age: '69',
  verified: true
}];
export function Testimonials() {
  return <section className="py-20 bg-[#1c2738]" data-id="element-314">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-315">
        <div className="text-center mb-16" data-id="element-316">
          <div className="flex justify-center mb-4 text-yellow-500 space-x-1" data-id="element-317">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-318" />)}
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-319">
            What Real Men Are Saying About Flow Regen
          </h2>
          <p className="text-slate-300 text-[19px]" data-id="element-320">
            Rated 4.4/5 from 2,847+ verified customers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-321">
          {reviews.map((review, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: idx * 0.1
        }} viewport={{
          once: true
        }} data-id="element-322">
              <Card className="h-full p-8 relative overflow-hidden group hover:shadow-lg transition-all duration-300 bg-slate-800/50 border-slate-700" data-id="element-323">
                <Quote className="absolute top-6 right-6 w-12 h-12 text-slate-700 group-hover:text-slate-600 transition-colors" data-id="element-324" />
                <div className="flex text-yellow-500 mb-4 space-x-1" data-id="element-325">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-326" />)}
                </div>
                <h3 className="text-xl font-bold text-white mb-4" data-id="element-327">
                  "{review.headline}"
                </h3>
                <p className="text-slate-300 mb-6 leading-relaxed text-[19px]" data-id="element-328">
                  "{review.text}"
                </p>
                <div className="flex items-center justify-between border-t border-slate-700 pt-4" data-id="element-329">
                  <div data-id="element-330">
                    <span className="font-bold text-white block text-[19px]" data-id="element-331">
                      {review.author}, Age {review.age}
                    </span>
                    {review.verified && <span className="text-[19px] text-emerald-400 font-medium flex items-center mt-1" data-id="element-332">
                        <span className="w-2 h-2 bg-emerald-500 rounded-full mr-1.5" data-id="element-333" />
                        Verified Buyer
                      </span>}
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}